import {
  Component,
  OnInit,
  OnDestroy,
  ResolvedReflectiveFactory,
  Input,
  ApplicationRef,
} from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  FormArray,
  ValidatorFn,
  ValidationErrors,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { FormTemplateDataEntryService } from "./../services/form-template-data-entry.service";
import { IDataEntryForm } from "./../models/data-entry.model";
import { ZpDataService } from "./../services/zp-data.service";
import { TextDictionaryService } from "./../services/text-dictionary.service";
import textList from "../../assets/data/text-dictionary.json";
import countries from "../../assets/data/countries.json";
import { v4 as uuid } from "uuid";
import { NgbCalendar } from "@ng-bootstrap/ng-bootstrap";
import { DynamicHelpers } from "./../helpers/dynamic-helpers";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "../models/user.model";
import { Subscription } from "rxjs";
import plantree from "../../assets/data/plan-tree.json";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { PreviousUrlService } from "../services/previous-url.service";
import { Location } from "@angular/common";
import { element } from "protractor";
import { PlanReviewRoutesService } from "../services/plan-review-routes.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { ThemeService } from "../theme/theme-service.service";

@Component({
  selector: "dynamic-form-data-entry",
  templateUrl: "./dynamic-form-data-entry.component.html",
  styleUrls: ["./dynamic-form-data-entry.component.scss"],
})
export class DynamicFormDataEntryComponent implements OnInit, OnDestroy {
  public selectFixBool: boolean;
  public formResult: string = "no results yet";
  public myFormGroup: FormGroup = new FormGroup({});
  public myFormTemplate: IDataEntryForm;
  public templateName;
  public Id;
  public newItemId;
  public myItem = {};
  public sectionTitle = "";
  public showHelp = false;
  public myTextList = textList;
  public myCountries = countries;
  public buttonText = "Next";
  public myOptionItem;
  public otherFreeText = false;
  public message: string;
  public showList = false;
  public hideList: string[] = [];
  public editMode = false;
  public dummyShowTrigger: boolean = false;
  //datePicker: NgbDateStruct;
  public date: { year: number; month: number };
  public submitted = false;
  public myUser: IUser;
  public subscription: Subscription;
  public dataIsLoaded: boolean;
  public id: any;
  @Input() public disabled: boolean;
  public breadCrumbText: any;
  public isIE = false;
  public previousLink: string;
  public statusTooltipMobile = [];
  public questionMarkMobile: boolean;
  public assetsPerm;
  public debtsPerm;
  public dailyLifePerm;
  public wishesPerm;
  private isDE = false;
  public myClient: any;
  public myClientSharedPlanUserId: any;
  public myCategoriesBalance: {}[];
  public itemName: any;
  public removeCheckmark: boolean;
  public removeToggle: boolean;
  public backTo: boolean;
  public returnToPlanReviewData: any;
  public getCategoryData: any;
  public currentUrl: string;
  public textAreaModel: string = "";
  public letterQuota: boolean = false;
  ownerPercentage: any;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public currencyChosen: string;
  currencyValue: any;
  showJointOwner: boolean;
  public ownersList: any = [];
  public owner: any;
  public isOwnerListEmpty: boolean;
  public selectedOwnersList: any = {};
  public errorMessage: boolean;
  public statusExplanations: boolean;
  public selectedOwners;
  public allMySharedPlans: {}[];
  public sharedPlan;
  public sharedPlanCategories: any;
  public ownersHashmap: {} = {}
  public hideInfoShowBox: boolean;
  public mapping = {
    'now': 'viewer now',
    'future': 'viewer future',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ftService: FormTemplateDataEntryService,
    private dictService: TextDictionaryService,
    private ZpDataService: ZpDataService,
    private fb: FormBuilder,
    private calendar: NgbCalendar,
    private userInfoService: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private previousUrl: PreviousUrlService,
    private location: Location,
    private planReviewRoutes: PlanReviewRoutesService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService,
    private route: ActivatedRoute,
    private appRef: ApplicationRef
  ) {
    this.planReviewRoutes.returnToPlanReview.subscribe((data) => {
      this.returnToPlanReviewData = data;
    });
    this.getInfoAndPassService.accessRightSection.subscribe((data) => {
      this.getCategoryData = data;
    });
    this.isIE = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    this.selectFixBool = true;
    this.subscription = userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
    });
    this.activatedRoute.paramMap.subscribe((params) => {
      this.templateName = params.get("templateName");
      this.Id = params.get("Id"); //for editting only -
      //both this and the dynamic edit component use the same html template.
      //The Id is not in use here.
      this.dataIsLoaded = false;
      this.getFields();
      this.dataIsLoaded = true;
    });
  }

  async ngOnInit() {
    this.subscription = this.userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
      // console.log('ngOnInit(), myUser - ', this.myUser);
    });
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    this.newItemId = uuid();
    this.previousLink = this.previousUrl.getPreviousUrl();
    if (
      this.previousLink != "/plan-review" &&
      this.previousLink != "/plan-review/assets" &&
      this.previousLink != "/plan-review/debts" &&
      this.previousLink != "/plan-review/dailyLife" &&
      this.previousLink != "/plan-review/wishes"
    ) {
      this.getCategoryData = null;
      this.returnToPlanReviewData = false;
    }
    if (window.screen.width <= 1100) {
      this.questionMarkMobile = true;
    } else {
      this.questionMarkMobile = false;
    }
    setTimeout(() => {
      this.selectFixBool = false;
    });
    this.myClient = this.myUser && this.myUser.sharedPlanUserId
      ? this.myUser && this.myUser.sharedPlanUserId
      : this.myUser;
    this.myClientSharedPlanUserId = this.myUser && this.myUser.sharedPlanUserId;

    if (this.myUser.sharedPlanUserId) {
      this.sharedPlanCategories = await this.ZpDataService.getPlan(this.myUser.sharedPlanUserId);
      console.log('sharedPlanCategories - 2', this.sharedPlanCategories)
      if (this.sharedPlanCategories) {
        for (let itemType in this.sharedPlanCategories) {
          for (let item of this.sharedPlanCategories[itemType]) {
            console.log('item! -', item)
            if (item.newJointOwners) {
              for (let owner of item.newJointOwners) {
                console.log('owner - ', owner)
                this.ownersHashmap[owner.owner.first + owner.owner.last] = owner.owner;
                // console.log('this.ownersSelectedHashmap - ', this.ownersSelectedHashmap)
                // this.test.push(this.ownersSelectedHashmap)
              }
            }
          }
        }
        if (Object.values(this.ownersHashmap).length === 0) {
          const chosenPlan = JSON.parse(sessionStorage.getItem('chosenSharedPlan'));
          this.ownersHashmap[chosenPlan.clientFirstName + chosenPlan.clientLastName] = {
            first: chosenPlan.clientFirstName, last: chosenPlan.clientLastName, relationship: 'Plan holder', default: true
          };
        }
        this.selectedOwners = this.ZpDataService.displaySharedPlansOwner(Object.values(this.ownersHashmap))
      }
    }
    else {
      this.selectedOwners = this.myUser.jointOwners
    }


    this.checkSectionsPlan();
  }

  async checkSectionsPlan() {
    this.myCategoriesBalance =
      await this.ZpDataService.getAllPlanCategoriesDashboardInfo(this.myUser);
  }

  async getFields() {
    // the appropriate form template from assets
    this.myFormTemplate = await this.ftService.getFormTemplateAsync(
      this.templateName
    );
    //An example of a possible implementation to keep all texts in a dictionary.
    //Works but not implemented.
    this.sectionTitle = await this.getText(this.myFormTemplate.sectionTitle);
    //adding fields to group for sending to save
    //otherwise we will add fields based on the template - see below.
    //I don't think we need these two fields when adding a new record
    this.myFormGroup.addControl("clientId", new FormControl(""));
    this.myFormGroup.addControl("Id", new FormControl(""));
    if (this.sectionTitle == "delegates") {
      this.myFormGroup.addControl("delegateId", new FormControl(""));
    }
    //adding system fields
    //region
    this.myFormGroup.addControl("lastUpdate", new FormControl(new Date()));
    this.myFormGroup.addControl("lastUpdateBy", new FormControl(""));
    this.myFormGroup.addControl("upToDateExpire", new FormControl(new Date()));
    this.myFormGroup.addControl("currencyValue", new FormControl(""));
    //endregion
    //Here we add the fields from the template as form objects
    this.myFormTemplate.fields.forEach(async (templateObject) => {
      //***FILL HIDELIST**
      //showFields are fields which are toggled by radiobuttonsshow.
      //We keep them in hideList
      //to make them non-visible on startup.
      // if(templateObject.fieldid.toLowerCase()=="review"){
      //   return;
      // }
      //#region
      if (templateObject.showFields) {
        templateObject.showFields.map((fieldToHide) => {
          this.hideList.push(fieldToHide);
        });
      }
      if (templateObject.inputtype.includes("conditionaldropdown")) {
        //adding urls in urlparamters that are fields to
        //the hidelist so they won't show up on init
        templateObject.urlparameters.forEach((element) => {
          if (element.urlArray) {
            element.urlArray.forEach((objectHideShow) => {
              if (objectHideShow.length > 0) {
                this.hideList.push(objectHideShow);
              }
            });
          }
        });
        //we need to give the form a kick in order to trigger the
        //hidding/showing of the correct objects
        //this.changeSelection(null, templateObject.urlparameters, localValue);
      }
      if (
        templateObject.inputtype == "radiobuttons" ||
        templateObject.inputtype == "yesnotogglehideshow"
      ) {
        //adding urls in urlparamters that are fields to
        //the hidelist so they won't show up on init
        templateObject.urlparameters.forEach((element) => {
          if (element.urlArray) {
            element.urlArray.forEach((url) => {
              // let kk = this.myFormTemplate.fields.find(field => {
              //   field.fieldid == url;
              // });
              // if (kk) {
              if (url.length > 0) {
                this.hideList.push(url);
              }
              //}
            });
          }
        });
      }

      //#endregion
      //adding the controls. formarray etc. is for the addable lists.
      //the controls will have fieldIds from the form template. In the html is a scan
      //that use the information in the form templae to fill in texts,
      //decide what object type to use and more
      if (!templateObject.inputtype.includes("formarray")) {
        if (templateObject.validators) {
          var myValidators: ValidatorFn[] = [];
          var validators: [{}] = templateObject.validators;
          templateObject.validators.map((validator) => {
            switch (validator["type"]) {
              case "max":
                myValidators.push(Validators.max(validator["value"]));
                break;
              case "min":
                myValidators.push(Validators.min(validator["value"]));
                break;
              case "maxLength":
                myValidators.push(Validators.maxLength(validator["value"]));
                break;
              case "minLength":
                myValidators.push(Validators.minLength(validator["value"]));
                break;
              case "required":
                myValidators.push(Validators.required);
                break;
              case "email":
                myValidators.push(Validators.email);
                break;
            }
          });
          if (
            templateObject.mandatory &&
            !myValidators.includes(Validators.required)
          ) {
            myValidators.push(Validators.required);
            //This way I can put off adding the validators array to all the templates. And
            //rely on templateObject.mandatory - which needs to be deleted from the system - TODO
          }
          if (templateObject.inputtype.includes("number")) {
            this.myFormGroup.addControl(
              templateObject.fieldid,
              new FormControl(null, Validators.compose(myValidators))
            );
            // console.log(this.myFormGroup.controls);
          } else {
            if (templateObject.inputtype.includes("multiselect")) {
              this.myFormGroup.addControl(
                templateObject.fieldid,
                new FormControl([])
              );
            } else {
              if (templateObject.inputtype.includes("yesnotoggleconditional")) {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl(false)
                );
              } else {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl("", Validators.compose(myValidators))
                );
              }
            }
          }
        } else {
          if (templateObject.inputtype.includes("number")) {
            this.myFormGroup.addControl(
              templateObject.fieldid,
              new FormControl(null)
            );
          } else {
            if (templateObject.inputtype.includes("multiselect")) {
              this.myFormGroup.addControl(
                templateObject.fieldid,
                new FormControl([], Validators.required)
              );
            } else {
              if (templateObject.inputtype.includes("yesnotoggle")) {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl(false)
                );
              } else {
                if (templateObject.inputtype.includes("multicheckbox")) {
                  this.myFormGroup.addControl(
                    templateObject.fieldid,
                    new FormControl([])
                  );
                } else {
                  this.myFormGroup.addControl(
                    templateObject.fieldid,
                    new FormControl("")
                  );
                }
              }
            }
          }
        }
      } else {
        let myUser = this.myUser.sharedPlanUserId;
        if (this.myUser.sharedPlanUserId) {
          myUser = this.myUser.sharedPlanUserId;
        } else {
          myUser = this.myUser;
        }
        let userName;
        if (myUser == this.myUser) {
          userName = this.myUser.firstName + " " + this.myUser.lastName;
        } else {
          userName = this.myUser.delegate.clientName;
        }
        let sharedPlanUserName = "";
        if (templateObject.inputtype.includes("formarray")) {
          if (templateObject.inputtype.includes("columns")) {
            //formarray of groups
            //I don't think this code is ever run - don't know what "columns" are.
            //TODO - move the content of "captions"
            //(which are now actualy the field names, not the capptions - my bad) to a new property "columns" -
            //a list of fields
            //in the form array columns and then use "captions" to fill in the captions of the columns.

            var myGroup;
            if (templateObject.columns) {
              //TODO - dynamically generate the below
            }
            //this is not the best code I have ever written...
            switch (templateObject.columns[0]) {
              case "Name": {
                switch (templateObject.columns.length) {
                  case 2: {
                    myGroup = this.fb.group({ Name: userName, Email: "" });
                    break;
                  }

                  case 3: {
                    //property - formarrayfourcolumns
                    myGroup = this.fb.group({
                      Name: "",
                      Percentage: 0,
                    });
                    break;
                  }
                }
                break;
              }
              case "Owner": {
                //mortgages formarraythree colums
                myGroup = this.fb.group({ Owner: userName, Percentage: "" });
                break;
              }
              case "sharedPlanOwner": {
                //for shared plans
                myGroup = this.fb.group({
                  sharedPlanOwner: sharedPlanUserName,
                  Percentage: "",
                });
                break;
              }
              case "Income": {
                myGroup = this.fb.group({ Income: "", Description: "" });
                break;
              }
              case "Expense": {
                myGroup = this.fb.group({ Expense: "", Description: "" });
                break;
              }
            }
            this.myFormGroup.addControl(
              templateObject.fieldid,
              new FormArray([myGroup])
            );
          } else {
            switch (templateObject.inputtype) {
              default: {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormArray([])
                );
                break;
              }
            }
          }
        } //the code below is never run, IMHO
        else {
          //this.myFormGroup.addControl(templateObject.fieldid, new FormControl(''));
          if (templateObject.inputtype.includes("number")) {
            this.myFormGroup.addControl(
              templateObject.fieldid,
              new FormControl(null)
            );
          } else {
            if (templateObject.inputtype.includes("multiselect")) {
              this.myFormGroup.addControl(
                templateObject.fieldid,
                new FormControl([])
              );
            } else {
              if (templateObject.inputtype.includes("yesnotoggle")) {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl(false)
                );
              } else {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl("")
                );
              }
            }
          }
        }
      }
      if (templateObject.listSource) {
        if (
          templateObject.inputtype == "dropdownshowmultiselect" ||
          templateObject.inputtype == "dropdownshowmultiselectid" ||
          templateObject.inputtype == "dropdownid"
        ) {
          let clientId = this.myUser
            ? this.myUser.sharedPlanUserId
              ? this.myUser.sharedPlanUserId
              : this.myUser.Id
            : undefined;
          //Get the dropdownlist
          templateObject.itemArray =
            await this.ZpDataService.getSectionItemIdsAndNames(
              templateObject.listSource,
              clientId,
              templateObject.itemType
            );
          // if(templateObject.inputtype == "dropdownid"){
          //   if(templateObject.fieldid=="itemName"){
          //     if(!this.myFormGroup.controls["itemNameText"]){
          //     this.myFormGroup.addControl("itemNameText", new FormControl(''));
          //     }
          //   }
          // }
        } else {
          if (templateObject.inputtype != "multicheckbox") {
            templateObject.items = await this.ZpDataService.getSectionItemNames(
              templateObject.listSource,
              this.myUser ? this.myUser.Id : undefined,
              templateObject.itemType
            );
          }
        }
      }
    });
    //this.myFormGroup.setValidators(this.emailValidator());//for confirming email
    if (this.myFormTemplate.finishedbuttontext) {
      // if (this.backTo = true && this.myFormTemplate.finished != true) {
      //   this.buttonText == 'Next'
      // } else {
      //   this.buttonText = this.myFormTemplate.finishedbuttontext;
      // }
    }
    //disabling hidden fields so the validation won't check them
    this.hideList.map((objectToDisable) => {
      if (this.myFormGroup.controls[objectToDisable]) {
        this.myFormGroup.controls[objectToDisable].disable();
      } else {
        //should log this
        let kk = 0;
      }
    });
  }

  async onSubmit() {
    //dummyShowTrigger is to trigger a *ngIf for hidng and showing fields
    // if(!this.loggedInUser){
    //   this.subscription = this.userInfoService.getMessage().subscribe(user => {
    //     this.loggedInUser = JSON.parse(user);
    //   });
    // }
    this.dummyShowTrigger = false;
    if (this.myFormGroup.invalid) {
      var kuku = DynamicHelpers.findInvalidControls(this.myFormGroup);
      //this.findInvalidControls(this.myFormGroup);
      if (kuku && kuku.length > 0) {
        this.submitted = true;
        //alert("The data in the form is not valid.
        //Please check that all fields have been filled in correctly. " + kuku)
        return;
      }
    }
    //checking if the itemname field was filled with the dropdownid object to save the textName. not nice
    //Do not use this.  I hope it isn't in use anymore. We save the ID instead.
    let comp = this.myFormTemplate.fields.find(
      (myField) => myField.inputtype == "dropdownid"
    );
    if (comp) {
      if (comp.fieldid == "itemName") {
        let myComp = document.getElementById("itemName");
        var lookupChosen: [{}];
        lookupChosen = myComp["options"]; //.find(mycomp=>mycomp["value"]==this.myFormGroup.value["itemName"]);
        let mytext = "";
        for (var i = 0; i < lookupChosen.length; i++) {
          if (lookupChosen[i]["value"] == this.myFormGroup.value["itemName"]) {
            mytext = lookupChosen[i]["text"];
          }
        }
        this.myFormGroup.addControl("lookupText", new FormControl(mytext));
      }
    }
    //this is a quick hack to save not as "Yes" and "No" rather as True or False so the edit yesnottooglehideshow can read it correctly
    //all this needs to changed to the data is dispalyed as Yes or No instead of True or False
    //doesn't work
    // comp = this.myFormTemplate.fields.find(myField => myField.inputtype == "conditionaldropdown");
    // if(comp && comp.urlparameters[0].option=="Yes"){
    //   if(this.myFormGroup.controls[comp.fieldid].value=="Yes"){
    //     this.myFormGroup.controls[comp.fieldid].value== true;
    //   }
    //   else{
    //     this.myFormGroup.controls[comp.fieldid].value== false;
    //   }
    // }

    if (this.myFormTemplate.finished) {
      let myUserId = this.myUser.sharedPlanUserId
        ? this.myUser.sharedPlanUserId
        : this.myUser.Id;
      //update the data of the item being held in the service
      //clearHiddenFieldValues checks all objects that are not
      //visible at save time and clear's thier data in order to prevent
      //unwanted data from being saved.
      await this.clearHiddenFieldValues();
      this.myFormGroup.value["Id"] = this.newItemId; //Guid like key for the new record
      this.myFormGroup.value["lastUpdate"] = new Date();
      this.myFormGroup.value["lastUpdateBy"] = this.myUser.Id;
      let currentUserId = this.myUser.sharedPlanUserId
        ? this.myUser.sharedPlanUserId
        : this.myUser.Id;
      this.myFormGroup.value["clientId"] = currentUserId;
      this.disabled = true;
      if (this.myFormTemplate.sectionTitle == "general expenses") {
        this.myFormGroup.value["itemName"] = "General Expenses";
      }
      // if (this.myFormTemplate.sectionTitle == "will") {
      //   this.myFormGroup.value["itemName"] = "Will";
      // }
      let pp = JSON.stringify(this.myFormGroup.value);
      //Data is beng stored and called from a JSON stored in application local variable.

      let data = await this.ZpDataService.addItem(
        pp,
        this.myFormTemplate.sectionTitle
      );

      if (data.success && this.myFormGroup.value["propertyId"]) {
        //only update the property associated w/ it if the item was successfully added (or else we can taint the data.
        if (this.myFormTemplate.sectionTitle == "insurance") {
          await this.ZpDataService.addInsuranceToProperty(
            this.myFormGroup.value["Id"] == ""
              ? data.itemId
              : this.myFormGroup.value["Id"],
            this.myFormGroup.value["propertyId"],
            myUserId
          );
        }
        if (this.myFormTemplate.sectionTitle == "mortgages") {
          await this.ZpDataService.addMortgageToProperty(
            this.myFormGroup.value["Id"] == ""
              ? data.itemId
              : this.myFormGroup.value["Id"],
            this.myFormGroup.value["propertyId"],
            myUserId
          );
        }
        if (this.myFormTemplate.sectionTitle == "utilities") {
          await this.ZpDataService.addUtilityToProperty(
            this.myFormGroup.value["Id"] == ""
              ? data.itemId
              : this.myFormGroup.value["Id"],
            this.myFormGroup.value["propertyId"],
            myUserId
          );
        }
        if (this.myFormTemplate.sectionTitle == "property") {
          //will update the UMI property field with the current user choices
          await this.ZpDataService.addPropertyToUtilitiesMortgagesInsurance(
            this.myFormGroup.value,
            myUserId
          );
        }
      }

      this.ZpDataService.addLog(
        this.sectionTitle,
        this.myFormGroup.value["Id"],
        this.myUser.Id,
        "",
        "",
        pp,
        "new"
      );
      if (window.location.href == "/plan-review") {
        this.location.back();
      } else {
        if (
          this.previousLink == "/plan-review" &&
          this.buttonText == "Finished"
        ) {
          this.router.navigate([this.previousLink]);
        } else if (
          (this.previousLink == "/home" ||
            this.previousLink == "/my-dashboard") &&
          this.buttonText == "Finished"
        ) {
          this.router.navigate([this.previousLink]);
        } else {
          this.goto(this.myFormTemplate.url);
          console.log('goTo 1');
          if (this.getCategoryData) {
            switch (this.getCategoryData) {
              case "categoryAssets":
                this.getInfoAndPassService.getInfoAndPass(this.getCategoryData);
                this.router.navigate(["/plan-review/assets"]);
                break;
              case "categoryDebts":
                this.getInfoAndPassService.getInfoAndPass(this.getCategoryData);
                this.router.navigate(["/plan-review/debts"]);
                break;
              case "categoryDailyLife":
                this.getInfoAndPassService.getInfoAndPass(this.getCategoryData);
                this.router.navigate(["/plan-review/dailyLife"]);
                break;
              case "categoryWishes":
                this.getInfoAndPassService.getInfoAndPass(this.getCategoryData);
                this.router.navigate(["/plan-review/wishes"]);
                break;
            }
          }
        }
      }
    } else {
      if (window.location.href == "/plan-review") {
        this.location.back();
      } else {
        this.goto(this.myFormTemplate.url);
        console.log('goTo 2');
        this.returnToPlanReviewData;
        this.getCategoryData;
        this.currentUrl = this.router.url;
        this.checkPercentageOwner(this.ownerPercentage);
      }
    }
  }

  checkPercentageOwner(event) {
    this.ownerPercentage = event;
    if ((this.ownerPercentage = false)) {
      return false;
    }
  }

  checkOnKeyUp() {
    if (this.textAreaModel.length >= 185) {
      this.letterQuota = true;
    } else {
      this.letterQuota = false;
    }
  }

  async clearHiddenFieldValues() {
    //we need to use the edit template that has all the fields in the same file.
    //TODO - base the new and edit on the same code and template. Hide and show each step for new
    let template = this.templateName as string;
    template = template.substr(0, template.indexOf("_"));
    let editFormTemplate = await this.ftService.getFormTemplateAsync(
      template + "-edit"
    );
    DynamicHelpers.clearHiddenFieldValues(editFormTemplate, this.myFormGroup);
  }

  async refresh() {
    await this.ZpDataService.revalidateCache();
    this.ZpDataService.changeMessage(
      JSON.stringify({ "cache revalidated": true })
    );
  }

  addNewItem() {
    if (this.myFormTemplate.finished == true) {
      const url = this.route.snapshot.url;
      const lastUrlSegment = url[url.length - 1].path;
      console.log('lastUrlSegment: ', lastUrlSegment);
      let modifiedUrlSegment;
      if (this.myFormTemplate.jointOwners == true) {
        modifiedUrlSegment = lastUrlSegment.replace(/_\d+$/, '_joint-owners');
      } else {
        modifiedUrlSegment = lastUrlSegment.replace(/_\d+$/, '_1');
      }
      setTimeout(() => {
        this.router.navigate(['/' + modifiedUrlSegment]);
        this.myFormGroup.reset;
      }, 1000);
    }
  }

  async goto(url: string) {
    console.log('goTo 3');
    this.submitted = false;
    if (this.myFormGroup.invalid) {
      if (this.myFormTemplate.introItem == true) {
        this.router.navigate(["/" + this.myFormTemplate.url]);
      }
    } else {
      if (this.myFormTemplate.finished != true) {
        url = this.myFormTemplate.url;
        this.router.navigate(["/" + url]);
      } else {
        console.log('Finished');
        this.router.navigate(["/" + url]);
      }
    }

    this.previousLink = this.previousUrl.getPreviousUrl();

    switch (this.myFormTemplate.subject.toLowerCase()) {
      // Delegates
      case "tell us about your delegate":
        if (this.previousLink == this.myFormTemplate.url) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // Delegates Access Rights
      case "set your delegate's access permissions":
        if (this.previousLink == this.myFormTemplate.url) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // Pensions
      case "add a pension":
        if (this.previousLink == this.myFormTemplate.url) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // Property
      case "add a property":
        if (this.previousLink == this.myFormTemplate.url) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // Utility
      case "add a utility":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "/utility_2_1" ||
          this.previousLink == "/utility_2_2" ||
          this.previousLink == "/utility_2_3" ||
          this.previousLink == "/utility_2_4" ||
          this.previousLink == "/utility_2_5" ||
          this.previousLink == "/utility_2_6" ||
          this.previousLink == "/utility_2_7" ||
          this.previousLink == "/utility_2_8" ||
          this.previousLink == "/utility_2_9"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // Work
      case "add an employment":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "work_2_1" ||
          this.previousLink == "work_2_2"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // Rent
      case "add a rent":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "rent_3_1" ||
          this.previousLink == "rent_3_2"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // Online Account
      case "add an online account":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "online-account_2_1" ||
          this.previousLink == "online-account_2_2" ||
          this.previousLink == "online-account_2_3"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // Power of Attorney
      case "add a power of attorney":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "power-of-attorney_1" ||
          this.previousLink == "power-of-attorney_2" ||
          this.previousLink == "power-of-attorney_3"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
    }
  }

  backto() {
    this.location.back();
    this.backTo = true;
    this.removeCheckmark = true;
    this.removeToggle = true;
  }

  getCurrencyValue(currencyValueSelected) {
    console.log(currencyValueSelected);
    this.myFormGroup.controls[currencyValueSelected.fieldId].setValue(
      currencyValueSelected.currencyValueToSend
    );
    // console.log(this.myFormGroup.controls);
  }

  createNewOwner() {
    this.router.navigate(['/account-settings/itemOwners']);
  }

  addOwnershipFormValue(ownerListSelected) {
    // console.log('addOwnershipFormValue(), ownerListSelected - ', ownerListSelected);
    if (!ownerListSelected.error) {
      this.myFormGroup.controls[ownerListSelected.fieldId].setValue(
        ownerListSelected.newJointOwnershipToSend
      );
    } else {
      this.myFormGroup.invalid;
      console.log('addOwnershipFormValue(), Invalid form. Total ownership must equal precisely 100 percent.')
      this.submitted = false;
      this.errorMessage = true;
    }
    // console.log(this.myFormGroup.controls);
  }

  getCheckboxValues(ev, data, fieldId) {
    const ownerObj = {
      owner: data,
    };
    // console.log('getCheckboxValues(), fieldId - ', fieldId);
    if (ev.target.checked) {
      this.ownersList.push(ownerObj);
      this.selectedOwnersList[data.first + data.last] = true;
    } else {
      const el = this.ownersList.find((itm) => itm.owner === data);
      if (el) this.ownersList.splice(this.ownersList.indexOf(el), 1);
      this.selectedOwnersList[data.first + data.last] = false;
      // console.log('getCheckboxValues(), unchecked');
    }
    if (this.ownersList.length === 0) {
      // console.log('getCheckboxValues(), ownersList is empty');
      this.isOwnerListEmpty = true;
    } else {
      // console.log('getCheckboxValues(), ownersList is not empty');
      this.isOwnerListEmpty = false;
    }
    // console.log('getCheckboxValues(),ownerList - ', this.ownersList);
    this.addOwnershipFormValue({
      fieldId: fieldId,
      newJointOwnershipToSend: this.ownersList,
    });
  }

  toggleExplanations($event) {
    $event.stopPropagation();
    this.statusExplanations = !this.statusExplanations;
    // if ((this.statusDropdownAdd2 = true)) {
    //   this.statusDropdownAdd2 = false;
    // }
  }

  forkClick(item, dummy, infoBox?) {
    this.myFormTemplate.url = item.url;
    console.log('infoxBox', infoBox)
  }

  forkClickYesNo(fieldId, urlparameters) {
    var myElements: [] = urlparameters;
    if (this.myFormGroup.controls[fieldId].value) {
      let myElementNo = myElements.find((element) => element["option"] == "No");
      this.myFormTemplate.url = myElementNo["url"];
    } else {
      let myElementYes = myElements.find(
        (element) => element["option"] == "Yes"
      );
      this.myFormTemplate.url = myElementYes["url"];
    }
  }

  getCurrency(currency) {
    this.currencyChosen = currency;
    console.log(this.currencyChosen);
  }

  forkClickYesNoHideShow(fieldId, urlparameters, init?) {
    var myElements: [] = urlparameters;
    //if (this.myFormGroup.controls[fieldId].value) {
    let myElementYes = myElements.find((element) => element["option"] == "Yes");
    let myElementNo = myElements.find((element) => element["option"] == "No");
    console.log(this.myFormGroup.controls[fieldId].value);
    console.log('myElementNo', myElementNo)
    var myInit = false;
    if (init) {
      myInit = true;
    }
    //enable the fields
    if (
      myInit
        ? this.myFormGroup.controls[fieldId].value
        : !this.myFormGroup.controls[fieldId].value
    ) {
      //Yes
      if (myElementYes["urlArray"][0]) {
        //it is a array of fields
        (myElementYes["urlArray"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].enable();
            this.manageHideFields("show", [url]);
          }
        });

        (myElementNo["urlArray"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].disable();
            this.manageHideFields("hide", [url]);
          }
        });
      } else {
        //one component without a array
        if (this.myFormGroup.controls[myElementYes["urlArray"]]) {
          this.myFormGroup.controls[myElementYes["urlArray"]].enable();
          this.manageHideFields("show", [myElementYes["urlArray"]]);
        }
        if (this.myFormGroup.controls[myElementNo["urlArray"]]) {
          this.myFormGroup.controls[myElementNo["urlArray"]].disable();
          this.manageHideFields("hide", [myElementNo["urlArray"]]);
        }
      }
    } //No
    else {
      //disable the fields
      if (myElementYes["urlArray"][0]) {
        //it is a array of fields
        (myElementYes["urlArray"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].disable();
            this.manageHideFields("hide", [url]);
          }
        });

        (myElementNo["urlArray"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].enable();
            this.manageHideFields("show", [url]);
          }
        });
      } else {
        //one component without a array
        if (this.myFormGroup.controls[myElementYes["urlArray"]]) {
          this.myFormGroup.controls[myElementYes["urlArray"]].disable();
          this.manageHideFields("hide", [myElementYes["urlArray"]]);
        }
        if (this.myFormGroup.controls[myElementNo["urlArray"]]) {
          this.myFormGroup.controls[myElementNo["urlArray"]].enable();
          this.manageHideFields("show", [myElementNo["urlArray"]]);
        }
      }
    }
    //}
  }

  showHide(choice, showList) {
    if (choice == "Yes") {
      this.showList = true;
    } else {
      this.showList = false;
    }
  }

  showMe(fieldName) {

    if (!this.hideList) {
      return true;
    }
    if (this.hideList.length == 0) {
      return true;
    }
    if (this.hideList.includes(fieldName)) {
      return false;
    } else {
      return true;
    }


  }

  manageHideFields(choice, showList: string[]) {
    if (choice == "show") {
      showList.map((kk) => {
        this.myFormGroup.controls[kk].enable();
        while (this.hideList.includes(kk)) {
          let index = this.hideList.indexOf(kk);
          this.hideList.splice(index, 1);
        }
      });
    } else {
      showList.map((kk) => {
        this.myFormGroup.controls[kk].disable();
        if (!this.hideList.includes(kk)) {
          this.hideList.push(kk);
          //valadation doesn't check controls that are disabled.
          //Otherwise if it was required it would throw a validation error
        }
      });
    }
    this.removeCheckmark = false;
    this.dummyShowTrigger = true;
  }

  onOptionSelected(event) {
    let value = event;
    let selected = value;
  }
  changeSelection(event, urls) {
    //added item? for dynamic edit
    //let selected = event.currentTarget.selectedOptions[0].innerHTML.trim() as string;
    let selected = event.target.value;
    //this.otherFreeText = selected.trim().toLowerCase() === "other";
    //let myUrls = urls.find(kk => kk.option == selected.trim()).urlArray;
    // let urlIsReallyAnotherField = this.myFormTemplate.fields.find(myField => {
    //   myField["fieldid"] == myUrls;
    // });
    var myUrlArray;
    let chosenUrlParameter = urls.find(
      (element) => element.option === selected
    );
    if (chosenUrlParameter.urlArray) {
      urls.forEach((param) => {
        if (param.urlArray) {
          // element.url.map(myUrl=>{
          //   if((item.url as [''])
          // })
          param.urlArray.forEach((element2) => {
            if ((chosenUrlParameter.urlArray as [""]).includes(element2)) {
              if (this.myFormGroup.controls[element2]) {
                this.myFormGroup.controls[element2].enable();
                this.manageHideFields("show", [element2]);
              }
            } else {
              if (this.myFormGroup.controls[element2]) {
                this.myFormGroup.controls[element2].disable();
                this.manageHideFields("hide", [element2]);
              }
              // the field will be disabled and not submitted,
              //so we don't need to reset the content.
              //this.myFormGroup.controls[element.url].setValue("");
            }
          });
        } //url to another form
        else {
          //this.myFormTemplate.url = urls.find(kk => kk.option == selected.trim()).url;
          // //if (param.url[0].length > 0) {
          // if (param.url == chosenUrlParameter.url) {
          //   this.myFormGroup.controls[param.url].enable();
          // }
          // else {
          //   this.myFormGroup.controls[param.url].disable();
          //   // the field will be disabled and not submitted,
          //so we don't need to reset the content.
          //this.myFormGroup.controls[element.url].setValue("");
          // }
          // //}
        }
      });
    } else {
      this.myFormTemplate.url = urls.find(
        (kk) => kk.option == selected.trim()
      ).url;
    }
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key); //this.myTextList.find(kk=>kk.key==key).value;
    return txt;
  }

  //see https://www.positronx.io/angular-7-select-dropdown-examples-with-reactive-forms/
  changeItem(e, itemName: string) {
    this.myFormGroup.controls[itemName].setValue(e.target.value, {
      onlySelf: true,
    });
  }

  private MatchConfirm(controls: string[]) {
    return (checkForm: FormGroup) => {
      let value1 = checkForm.controls[controls[0]];
      let value2 = checkForm.controls[controls[1]];

      if (value1.value === value2.value) {
        return value2.setErrors(null);
      } else {
        return value2.setErrors({ notEquivalent: true });
      }
    };
  }

  private MatchConfirmed(e, controls: string[]) {
    if (!this.myFormGroup.controls[controls[0]]) {
      return;
    }
    if (!this.myFormGroup.controls[controls[1]]) {
      return;
    }
    let value1 = this.myFormGroup.controls[controls[0]];
    let value2 = this.myFormGroup.controls[controls[1]];

    if (value1.value === value2.value) {
      value2.setErrors(null);
    } else {
      value2.setErrors({ notEquivalent: true });
      //value2.updateValueAndValidity();
    }
  }

  private emailValidator(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      if (!group.controls["email"]) {
        return;
      }
      if (!group.controls["emailConfirm"]) {
        return;
      }
      const email = group.controls["email"];
      const confirmEmail = group.controls["confirmEmail"];
      if (email.value !== confirmEmail.value) {
        confirmEmail.setErrors({ notEquivalent: true });
      } else {
        confirmEmail.setErrors(null);
      }
      return;
    };
  }
  // async getItemNames(section){
  //   return await this.ZpDataService.getSectionItemNames(section);
  // }
  getIcon(mysection) {
    let myItemObject = plantree.find(
      (kk) => kk.sectionObjects["section"] == mysection
    )[0][""];
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

// selectToday() {
//   this.datePicker = this.calendar.getToday();
// }

// onDateSelection(date: NgbDate) {
//   if (!this.fromDate && !this.toDate) {
//     this.fromDate = date;
//   } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
//     this.toDate = date;
//   } else {
//     this.toDate = null;
//     this.fromDate = date;
//   }
// }

// isHovered(date: NgbDate) {
//   return this.fromDate && !this.toDate &&
//this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
// }

// isInside(date: NgbDate) {
//   return date.after(this.fromDate) && date.before(this.toDate);
// }

// isRange(date: NgbDate) {
//   return date.equals(this.fromDate) || date.equals(this.toDate)
//|| this.isInside(date) || this.isHovered(date);
// }
